import * as React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import siteConfig from "configs/site-config";
import Socials from "components/socials";
import { CONTENT_WIDTH } from "components/page";

const Footer = () => {
  return (
    <Box as="footer" borderTop="1px solid" borderColor="line">
      <Flex
        maxW={CONTENT_WIDTH}
        mx="auto"
        px={6}
        py={6}
        align="center"
        justify="space-between"
        gap={4}
        wrap="wrap"
      >
        <Text fontFamily="mono" fontSize="xs" color="muted">
          © {new Date().getFullYear()} {siteConfig.author.name}
        </Text>
        <Socials mr={-2} />
      </Flex>
    </Box>
  );
};

export default Footer;
